<template>
  <div v-html="identicon" />
</template>

<script setup>
import { computed } from 'vue';
import { toSvg } from "jdenticon";

const props = defineProps({
  text: {
    type: String,
    required: true,
    default: "undefined",
  },
  size: {
    type: Number,
    required: false,
    default: 24,
  }
});

const identicon = computed(() => toSvg(props.text, props.size))
</script>
